var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightNotificationBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification_btn",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M0,0H26V26H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notifications-none",
    transform: "translate(5 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.5,20a2,2,0,0,1-2-2h4A2,2,0,0,1,8.5,20ZM17,17H0V16l2-2V8.5A6.375,6.375,0,0,1,3.413,4.45,6.619,6.619,0,0,1,7,2.2V1.5a1.5,1.5,0,1,1,3,0v.7a6.62,6.62,0,0,1,3.588,2.25A6.375,6.375,0,0,1,15,8.5V14l2,2v1ZM8.5,4A4.505,4.505,0,0,0,4,8.5V15h9V8.5A4.505,4.505,0,0,0,8.5,4Z",
    fill: "#36495a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightNotificationBtn);
export default __webpack_public_path__ + "static/media/Light_Notification_Btn.011b556aba960324ff061d6e13bb9249.svg";
export { ForwardRef as ReactComponent };